import { siteInfo, contactItem } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.name}汇集西瓜视频免费、91在线视频、小蓝视频、久久视频等多平台优质资源，提供电影电视剧全集免费在线观看。无需付费，即点即播不缓冲，畅享高清免费影视盛宴。
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold text-background-50 tracking-wide">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '焦点推荐', href: '#carousel' },
                { label: '热门榜单', href: '#ranking' },
                { label: '话题热榜', href: '#topics' },
                { label: '平台特色', href: '#features' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold text-background-50 tracking-wide">
              内容分类
            </h4>
            <div className="flex flex-col gap-2.5">
              {['电影大全', '电视剧库', '综艺娱乐', '动漫频道', '纪录片专区'].map((cat) => (
                <a
                  key={cat}
                  href="#cards"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="text-sm font-semibold text-background-50 tracking-wide">
              联系我们
            </h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>
                {contactItem.email}
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-wechat-line mr-2"></i>
                微信：{contactItem.wechat}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
              <span className="text-sm text-background-500 font-medium">合作伙伴：</span>
              <span className="text-sm text-background-500">西瓜视频 · 91在线视频 · 小蓝视频 · 久久视频 · 更多合作伙伴敬请期待</span>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2026 {siteInfo.name} 版权所有。本站内容来源于网络公开资源，仅供学习交流使用。
              </p>
              <div className="flex items-center gap-4">
                <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">
                  回到顶部 <i className="ri-arrow-up-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}